import cronstrue from 'cronstrue';

/**
 * Converts any valid cron expression to a human-readable description using cronstrue.
 * Falls back to the raw expression if cronstrue cannot parse it.
 */
export function cronToHumanReadable(cronExpression: string): string {
  if (!cronExpression) return cronExpression ?? '';
  try {
    return cronstrue.toString(cronExpression);
  } catch {
    return cronExpression;
  }
}
